import { Component, EventEmitter, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { ContextService } from 'src/app/services/context.service';
import { DataClientService } from 'src/app/services/data-client.service';
import { DataNotClientService } from 'src/app/services/data-not-client.service';
import { LoadingService } from 'src/app/services/loading.service';
import { GenericErrorResponse, StaticAssets, StaticAssetsService } from 'src/app/services/static-assets';
import { GenericErrorType, StepsClientTypes, StepsNotClientTypes } from 'src/app/shared/enums';
import { UiActions } from 'src/app/store/actions';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { OnboardingProductsStore } from 'src/app/store/store';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'lib-service-error',
  templateUrl: './service-error.component.html',
  styleUrls: ['../../../global.scss', './service-error.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ServiceErrorComponent implements OnInit {
  @Output() retry = new EventEmitter<any>();

  staticAssetsUrl = environment.staticScripts.staticAssets;
  dataService: DataNotClientService | DataClientService;
  GenericErrorType;

  public icon = `${this.staticAssetsUrl}assets/icons/error/reintentar.svg`;
  public title = '¡Oops, tuvimos un problema!';
  public principal_message = 'Ha ocurrido un problema con la carga, por favor vuelve a intentarlo';
  public button_message = 'Reintentar';

  subs = new Subscription();

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    private dataNotClientService: DataNotClientService,
    private dataClientService: DataClientService,
    private staticAssetsService: StaticAssetsService,
    private contextService: ContextService,
    public loadingService: LoadingService
  ) {
    this.handleWhiteContainer('none');
  }

  ngOnInit() {
    this.GenericErrorType = GenericErrorType;
    this.store.dispatch(TagPage({ text: 'service-error' }));
    this.dataService = this.contextService.isPrivateSite() ? this.dataClientService : this.dataNotClientService;
    if (this.dataService.getGenericErrorType() !== GenericErrorType.DEFAULT_ERROR) {
      this.subs.add(this.getGenericInfoError().subscribe((data) => {
        this.handleWhiteContainer('block');
        const errorType = this.dataService.getGenericErrorType();
        this.title = data[errorType].title;
        this.icon = this.staticAssetsUrl + data[errorType].icon;
        this.principal_message = data[errorType].principal_message;
        this.button_message = data[errorType].button_message;
      }));
    } else {
      this.handleWhiteContainer('block');
    }
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 200);
  }

  getGenericInfoError(): Observable<GenericErrorResponse> {
    return this.staticAssetsService.getStaticResources<GenericErrorResponse>(StaticAssets.genericError);
  }

  tryRetry() {
    if (this.dataService.getGenericErrorType() === GenericErrorType.SUCURSAL_DERIVATION ||
      this.dataService.getGenericErrorType() === GenericErrorType.REJECTED_REQUEST ||
      this.dataService.getGenericErrorType() === GenericErrorType.EXIST_CLIENT ||
      this.dataService.getGenericErrorType() === GenericErrorType.ABR_YELLOW_DERIVATION) {
      return this.checkOffices();
    }
    const step = this.contextService.isPrivateSite() ? StepsClientTypes.STEP_OFFER : StepsNotClientTypes.STEP_PUBLIC_LANDING;
    this.store.dispatch(UiActions.Navigate({ step }));
  }

  // Metodo para ocultar o mostrar el contenedor blanco - recordar solo usar 'none' o 'block'
  handleWhiteContainer(canShow: string) {
    const inputElement = document.getElementById('white-container');
    inputElement.style.display = canShow;
  }

  checkOffices() {
    window.open('https://www.bancofalabella.pe/sucursales', '_blank');
  }
}
